import { media, style } from 'typestyle'

/* Styles ======================================================================================= */
import { StyleClass } from '../style-class'

/* Types ======================================================================================== */
type ClassNames = {
  /**
   * Base class for tab
   */
  base: string

  /**
   * Base class for tab
   */
  proped: {
    active: string
  }
}

type ClassProps = object

const getNames: (props: ClassProps, theme: any) => ClassNames = () => {
  const base = style({
    display: 'none',
    flexDirection: 'column',
    pageBreakInside: 'avoid',
    ...media(
      { type: 'print' },
      {
        display: 'flex !important',
        width: '100%',
        $nest: {
          '.aeki-box': {
            width: '100%',
          },
        },
      },
    ),
  })

  const proped = {
    active: style({ display: 'flex', width: '100%' }),
  }

  return {
    base,
    proped,
  }
}

/* Export ======================================================================================= */
export const tabClass = new StyleClass<ClassNames, ClassProps>(getNames)
